var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("generic-header"),
      _vm._v(" "),
      _c("form", { attrs: { method: "POST", action: "token/issue" } }, [
        _c("input", {
          attrs: { type: "hidden", name: "successUrl" },
          domProps: { value: _vm.successUrl },
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", name: "failUrl" },
          domProps: { value: _vm.state.relativeBaseUrl + "log/in" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.state.fullTitle))]),
            _vm._v(" "),
            _c("h6", [_vm._v(_vm._s(_vm.methods))]),
            _vm._v(" "),
            _vm._l(_vm.messages, function (message) {
              return _c(
                "b-alert",
                {
                  key: message.text,
                  attrs: {
                    show: "",
                    dismissible: "",
                    variant: message.variant || "danger",
                  },
                },
                [_vm._v(_vm._s(message.text))]
              )
            }),
            _vm._v(" "),
            _vm.state.authDirectEnable || _vm.state.authActiveDirectoryEnable
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "userName" } }, [
                        _vm._v("User Name"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        ref: "fldUserName",
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "userName",
                          name: "userName",
                          placeholder: "Enter User Name",
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.state.authDirectEnable || _vm.state.authActiveDirectoryEnable
              ? _c("div", { staticClass: "row" }, [_vm._m(0)])
              : _vm._e(),
            _vm._v(" "),
            _vm.state.authDirectEnable || _vm.state.authActiveDirectoryEnable
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" },
                      },
                      [_vm._v("Login")]
                    ),
                    _vm._v(" "),
                    _vm.state.authAzureADEnable
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { href: _vm.state.authAzureLoginUrl },
                          },
                          [_vm._v("Login with Azure AD")]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.state.authDirectEnable &&
            !_vm.state.authActiveDirectoryEnable &&
            _vm.state.authAzureADEnable
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { href: _vm.state.authAzureLoginUrl },
                      },
                      [_vm._v("Login with Azure AD")]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-sm" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "password" } }, [_vm._v("Password")]),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "password",
            id: "password",
            name: "password",
            placeholder: "Password",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }